<template>
  <div class="edit-detail">
    <div class="edit-nav">
      <van-nav-bar
        :title="`${staffName}的日报`"
        left-arrow
        @click-left="onClickLeft"
      />
      <div class="edit-date">
        <span>日期：{{reportDate}}</span>
        <span style="color:dodgerblue">{{ supplementFlag == 0 ? '补交' : ''}}</span>
        <span>被考核人：{{staffName}}</span>
      </div>
      <div class="edit-date">
        <span>提交时间：{{ lastSubmissionTime }}</span>
      </div>
    </div>
    <div class="edit-label" style="margin-bottom:0.27rem">任务打分</div>
    <div>
      <a-collapse :activeKey="activeKey" expand-icon-position="right">
        <a-collapse-panel v-for="(item, index) in taskData" :key="String(index)" :header="item ? `岗位：${item.postName}` : ''" >
          <div v-for="(i, index1) in item.sysStaffReportTaskList" :key="index1" style="padding: 10px;border-top: 1px solid #DADADA;">
            <div>岗位职责：{{i.dutyDesc}}</div>
            <div>任务名称：{{i.taskName}}</div>
            <div><span>完成率：{{i.reachRate}}%</span><span style="margin-left: 0.6rem;">任务自评：{{i.selfComment}}分</span></div>
            <span>领导评分：</span><a-input-number v-if="status !=2" v-model="i.leadComment" :min="0" :max="100" :disabled="status !=2?false:true" class="color-style"/>
            <span v-else>{{i.leadComment}}</span>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <div class="edit-label" style="margin-top:0.43rem;margin-bottom:0.27rem">工作汇报</div>
    <div class="edit-workReport">
      <a-textarea v-model="content" :disabled="true" class="ant-textarea" />
    </div>
    <div class="edit-label" style="margin-top:0.43rem;margin-bottom:0.27rem">附件</div>
    <div class="annex" v-for="(item,index) in resourcesList" :key="index">
      <div>
        <img style="width: 24px;height: 21px" src="../assets/file@2x.png" />
        <span>{{item.name}}{{item.suffix}}</span>
      </div>
      <van-button @click="preview(item.url)" type="primary">预览</van-button>
    </div>
    <div style="margin-top:20px;">
        <div style="margin-bottom: 0.43rem" class="edit-label">
          汇报给：<a-tree-select
            style="width: 183px"
            :dropdown-style="{
              overflow: 'auto',
            }"
            allow-clear
            v-model="approverId"
            :tree-data="addressData"
            :replaceFields="{
              children: 'childList',
              title: 'name',
              key: 'id',
              value: 'id',
            }"
            class="color-style"
            disabled
          >
          </a-tree-select>
        </div>
        <div style="margin-bottom: 0.43rem" class="edit-label">
          抄送人：<a-tree-select
            style="width: 183px;"
            :dropdown-style="{
              overflow: 'auto',
            }"
            allow-clear
            multiple
            v-model="copyIds"
            :tree-data="addressData"
            :replaceFields="{
              children: 'childList',
              title: 'name',
              key: 'id',
              value: 'id',
            }"
            class="color-style"
            disabled
          >
          </a-tree-select>
        </div>
        <div class='edit-label'>
          是否公开：<a-switch checked-children="是" un-checked-children="否" disabled v-model="switchValue" />
        </div>
      </div>
    <div v-if="isRate === 0 && status != 2" class="edit-submit1" @click="handleSubmit">提交</div>
    <div v-if="isRate === 0 && status != 2" class="edit-submit2" @click="submitAndOne">提交并审核下一个</div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import { getTaskDetail, handleGrade, getAddressBook } from '../axios/services' 
import { mapState } from 'vuex'
export default {
  data() {
    return {
      taskData: [],
      reportId: '',
      activeKey: [],
      resourcesList: [],
      status: '',
      content: 'sss',
      staffName: '',
      reportDate: '',
      isRate: '',
      switchValue: '',
      addressData: [],
      approverId: '',
      copyIds:[],
      supplementFlag: '',
      lastSubmissionTime: ''
    };
  },
  computed: {
    ...mapState(['dailyData'])
  },
  methods: {
    onClickLeft() {
      // this.$router.push('/daily')
      window.history.go(-1);
    },
    handleSubmit() {
      let params = []
      let flag = false
      this.taskData.forEach(item => {
        if(item.sysStaffReportTaskList && item.sysStaffReportTaskList.length > 0) {
          params = params.concat(item.sysStaffReportTaskList)
        }
      });
      params.forEach(item => {
        if(item.leadComment==null) {
          flag = true
        }
      })
      if(flag) return Toast('没填写评分分数')
      params = params.map(item => ({...item, status: '2'}))
      const data = {
        sysStaffReportTaskList: params,
        companyId: this.dailyData.companyId
      }
      handleGrade(data).then(res => {
        if(res.data.code === 0) {
          this.$router.push('/daily')
        }else {
          Toast.fail(res.data.msg)
        }
      })
    },
    submitAndOne() {
      let params = []
      let flag = false
      this.taskData.forEach(item => {
        if(item.sysStaffReportTaskList && item.sysStaffReportTaskList.length > 0) {
          params = params.concat(item.sysStaffReportTaskList)
        }
      });
      params.forEach(item => {
        if(item.leadComment==null) {
          flag = true
        }
      })
      if(flag) return Toast('没填写评分分数')
      params = params.map(item => ({...item, status: '2'}))
      const data = {
        sysStaffReportTaskList: params,
        companyId: this.dailyData.companyId
      }
      handleGrade(data).then(res => {
        if(res.data.code === 0) {
          if(res.data.data) {
            this.$router.push(`/daily-detail/${res.data.data}`)
            const param = {
              reportId: res.data.data,
              companyId: this.dailyData.companyId
            }
            getTaskDetail(param).then(res => {
              if(res.data.code === 0) {
                this.taskData = res.data.data.sysStaffReportTaskQueryVoList
                this.resourcesList = res.data.data.resourcesList
                this.status = res.data.data.status
                this.content = res.data.data.content
                this.staffName = res.data.data.staffName
                this.reportDate = res.data.data.reportDate
                this.supplementFlag = res.data.data.supplementFlag;
                this.lastSubmissionTime = res.data.data.lastSubmissionTime;
              }else {
                Toast.fail(res.data.msg)
              }
            })
          }else{
            Toast('已审核完')
          }
        }
        if(res.data.code !== 0) {
          Toast.fail(res.data.msg)
        }
      })
    },
    preview(param) {
      window.location.href = "jsToOc://fujianJump?url=" + param
    },
    getAddressData() {
      const params = {
        companyId: this.dailyData.companyId,
      };
      getAddressBook(params).then((res) => {
        if (res.data.code === 0) {
          this.addressData = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
  },
  created() {
    this.reportId = this.$route.params.id
    const params = {
      reportId: this.reportId,
      companyId: this.dailyData.companyId
    }
    getTaskDetail(params).then(res => {
      if(res.data.code === 0) {
        this.taskData = res.data.data.sysStaffReportTaskQueryVoList
        this.resourcesList = res.data.data.resourcesList
        this.reportDate = res.data.data.reportDate
        this.staffName = res.data.data.staffName
        this.status = res.data.data.status
        this.content = res.data.data.content
        this.isRate = res.data.data.isRate
        this.switchValue = res.data.data.isOpen === 0 ? true : false
        this.approverId = res.data.data.approverId
        this.copyIds=res.data.data.copyIds
        this.supplementFlag = res.data.data.supplementFlag;
        this.lastSubmissionTime = res.data.data.lastSubmissionTime;
        this.activeKey = this.taskData.map(
          (item, index) => {
            return index;
          }
        );
      }else {
        Toast.fail(res.data.msg)
      }
    })
    this.getAddressData()
  }
};
</script>
<style scoped>
  .edit-detail {
    width: 100%;
    background: #f9f9f9;
    min-height: 100vh;
    padding: .4rem;
  }
  .edit-nav {
    width: 100vw;
    margin-left: -.4rem;
    background: #ffffff;
    padding: .4rem;
    margin-top: -.4rem;
  }
  .edit-detail /deep/ .van-nav-bar {
    background: none;
  }
  .van-hairline--bottom::after {
    border: none;
  }
  .van-nav-bar /deep/ .van-nav-bar__left {
    padding: 0 !important;
  }
  .van-nav-bar /deep/ .van-nav-bar__arrow {
    font-size: 24px !important;
    color: black;
  }
  .edit-date {
    display: flex;
    justify-content: space-between;
  }
  .edit-label {
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #323233;
    font-size: .4rem;
  }
  .ant-collapse-item /deep/.ant-collapse-header {
    width: 100%;
    height: 1rem;
    padding: .2rem !important;
    color: inherit;
  }
  .ant-collapse {
    background: none !important;
  }
  /* .ant-collapse-item /deep/ .ant-collapse-content {
    background-color: #F2F2F2 !important;
  } */
  .ant-collapse-item /deep/ .ant-collapse-content-box {
    padding: 0px !important;
  }
  .ant-textarea {
    min-height: 4rem;
    color: #333;
  }
  .color-style{
    color: #333 !important;
  }
  .ant-input-number {
    width: 60%;
    margin-bottom: .2rem;
  }
  .annex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
  }
  .van-button {
    height: 1rem;
    margin: .3rem .5rem;
  }
  .edit-submit1{
    width: 93%;
    height: 1rem;
    border-radius: .1rem;
    color: white;
    line-height: 1rem;
    text-align: center;
    margin: .5rem auto;
    background: #1584ff;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 0px #80bcff; 
    /* position:absolute;
    bottom: 68px;
    left: 12px; */
  }
  .edit-submit2{
    width: 93%;
    height: 1rem;
    border-radius: .1rem;
    line-height: 1rem;
    text-align: center;
    margin: 0 auto;
    /* position:absolute; */
    border: 1px solid #ccc;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    color: #1584ff;
    /* bottom: 20px;
    left: 12px; */
  }
  .ant-input-number-handler-wrap {
    display: none
}
</style>
